import {
  Box,
  Paper,
  styled,
  Table,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { TableVirtuoso } from "react-virtuoso";

export const StyledTableVirtuoso = styled(TableVirtuoso)`
  min-width: 100%;
  border: 1px solid
    ${({ theme, border }) => (!!border ? theme.palette.divider : "none")};

  &.rtl * {
    direction: rtl;
  }
  &.rtl td:not(.MuiTableCell-alignCenter):not(.MuiTableCell-alignLeft),
  &.rtl th:not(.MuiTableCell-alignCenter):not(.MuiTableCell-alignLeft) {
    text-align: right;
  }
  &.i-0 * {
    background-color: ${({ theme }) =>
      theme.palette.background.default} !important;
    & {
      border-bottom: none !important;
    }
  }
`;

export const TablePaper = styled(Paper)`
  box-shadow: none;
  overflow: auto;
  background-color: ${({ theme }) =>
    theme.palette.background.default} !important;
  --Paper-shadow: none !important;
  --Paper-overlay: none !important;
`;

export const FixedTable = styled(Table)`
  border-collapse: separate;
  table-layout: fixed;
`;

export const StyledTableRow = styled(TableRow)`
  background-color: ${({ theme }) => theme.palette.background.default};
`;

export const StyledTableCell = styled(TableCell)`
  position: relative;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};

  tbody tr:has(&:hover) td {
    background-color: ${({ theme }) => theme.palette.background.secondary};
  }
`;

export const HeaderTableCell = styled(StyledTableCell)`
  background-color: ${({ theme }) => theme.palette.background.secondary};
  user-select: none;
`;

export const ChipWrapper = styled(StyledTableCell)`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  align-items: center;
`;

export const HyperLinkTypography = styled(Typography)`
  width: 100%;
  cursor: pointer;
  ${({ $truncate }) =>
    $truncate &&
    `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
  &:hover {
    text-decoration: underline;
  }
`;

export const EmptyStateWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 1rem;
`;
